<div class="flex flex-col items-center gap-6">
  @for (item of stepConfigs(); track $index) {
    <div
      class="grid grid-cols-[20px_1fr] items-center gap-1 rounded-full bg-(--steplist-pill-background) text-(--steplist-icon-color) px-4 py-2"
    >
      <div class="flex items-center">
        @if (item.status === "completed") {
          <app-dynamic
            componentName="SvgIcon"
            [props]="{ name: 'check', size: '16' }"
          />
        } @else {
          <div class="size-4 animate-spin rounded-full border-2 border-current border-t-transparent"></div>
        }
      </div>

      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: item.textConfig }"
      />
    </div>
  }
</div>
